import React,{useEffect, lazy} from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  useLocation
} from "react-router-dom";
// import Login from './pages/login';
// import ProductList from './pages/productList';
// import ProductDialog from './pages/productDialog';
// import ShoppingCard from './pages/shoppingCard';
// import CheckoutForm from './admin/checkout';
// import DetailToCheckout from './admin/detailtocheckout';
// import Paymentgetway from './pages/paymentgetway';
// import WatchTv from './about/watchtv';
// import Aboutus from './about/aboutus';
// import Privacy from './about/privacy';
// import Faq from './about/faq';
// import ContactUs from './about/contactus';
// import Whatsapp from './admin/whatsapp';
// import Signin from './admin/signin';
// import Offer from './pages/offer';
// import Registration from './pages/registration';
// import Productpage from './pages/productpage';
// import Main from './grocery/main';
// import GroceryList from './grocery/groceryList';
// import GroceryDialog from './grocery/productdialog';
// import OrganicProductpage from './grocery/productpage';
// import SellerLoginPage from './about/sellerLoginPage';
// 📦 Lazy loaded components
const Login = lazy(() => import('./pages/login'));
const ProductList = lazy(() => import('./pages/productList'));
const ProductDialog = lazy(() => import('./pages/productDialog'));
const ShoppingCard = lazy(() => import('./pages/shoppingCard'));
const CheckoutForm = lazy(() => import('./admin/checkout'));
const DetailToCheckout = lazy(() => import('./admin/detailtocheckout'));
const Paymentgetway = lazy(() => import('./pages/paymentgetway'));
const WatchTv = lazy(() => import('./about/watchtv'));
const Aboutus = lazy(() => import('./about/aboutus'));
const Privacy = lazy(() => import('./about/privacy'));
const Faq = lazy(() => import('./about/faq'));
const ContactUs = lazy(() => import('./about/contactus'));
const Whatsapp = lazy(() => import('./admin/whatsapp'));
const Signin = lazy(() => import('./admin/signin'));
const Offer = lazy(() => import('./pages/offer'));
const Registration = lazy(() => import('./pages/registration'));
const Productpage = lazy(() => import('./pages/productpage'));
const Main = lazy(() => import('./grocery/main'));
const GroceryList = lazy(() => import('./grocery/groceryList'));
const GroceryDialog = lazy(() => import('./grocery/productdialog'));
const OrganicProductpage = lazy(() => import('./grocery/productpage'));
const SellerLoginPage = lazy(() => import('./about/sellerLoginPage'));
const ThankYouPage = lazy(() => import('./about/thankyoupage'));
const DashBoard = lazy(() => import('./admin/dashboard'));
const SellerProducts = lazy(() => import('./admin/sellerProducts'));
const EditProducts = lazy(() => import('./admin/editProducts'));
const SellerPolicy = lazy(() => import('./about/sellerPolicy'));
const ForgetPassword = lazy(() => import('./admin/forgetPassword'));
const LoginSeller = lazy(() => import('./admin/loginSeller'));

// import ThankYouPage from './about/thankyoupage';
// import DashBoard from './admin/dashboard';
// import SellerProducts from './admin/sellerProducts';
// import EditProducts from './admin/editProducts';
// import SellerPolicy from './about/sellerPolicy'
// import ForgetPassword from './admin/forgetPassword';
// import LoginSeller from './admin/loginSeller';

function ErrorBoundry() {
  return (
    <div className='flex flex-col justify-center items-center min-h-screen p-5'>
      <h1 className='text-4xl font-bold'>Oops! Connection lost</h1>
      <p>
      you refresh the page or Looks like you're back from payment process.
      </p>
      <a href="/product/decor" className="mt-4 mb-8 w-1/2 rounded-md bg-gray-900 px-6 py-3 font-medium text-white">Home</a>
    </div>
  )
}

// ✅ Separate component — must be INSIDE BrowserRouter to use useLocation
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null; // renders nothing
}


const router = createBrowserRouter([
  {
    path: "/",
    element:(<>
      <PageTracker/>
    <Main />
    </>)
  },
  {
    path: "product/:main",
    element: <ProductList />,
    errorElement: <ErrorBoundry />
  },
  {
    path: "product/:main/:subproduct",
    element: <ProductDialog />,
    errorElement: <ErrorBoundry />
  },
  {
    path: "amazing-product/:item/:subproduct",
    element: <Productpage />,
    errorElement: <ErrorBoundry />
  },
  {
    path: "product/shoppingCard",
    element: <ShoppingCard />
  },
  {
    path: "/login",
    element: <Registration />
  },
  {
    path: "/watchtv",
    element: <WatchTv />
  },
  {
    path: "/about",
    element: <Aboutus />
  },
  {
    path: "/privacy",
    element: <Privacy />
  },
  {
    path: "/faq",
    element: <Faq />
  },
  {
    path: "/contact",
    element: <ContactUs />
  },
  {
    path: "/sellerpolicy",
    element: <SellerPolicy />
  },
  {
    path: "/paymentgetway",
    element: <Paymentgetway />,
    errorElement: <ErrorBoundry />
  },
  {
    path: '/signin',
    element: <Signin />
  },
  {
    path: '/signin/seller',
    element: <SellerLoginPage/>,
    errorElement: <ErrorBoundry />
  },
  {
    path: '/login/seller',
    element: <LoginSeller/>,
    errorElement: <ErrorBoundry />
  },
  {
    path: '/forgetpassword',
    element: <ForgetPassword/>,
    errorElement: <ErrorBoundry />
  },
  {
    path:'/dashboard/seller',
    element:<DashBoard/>,
    errorElement: <ErrorBoundry />
  },
  {
    path:'/dashboard/sellerproducts',
    element:<SellerProducts/>
  },
  {
    path: "/savesoil",
    element: <Login />,
  },
  {
    path: "/checkout",
    element: <CheckoutForm />
  },
  {
    path: "personalized-gift/:item/:subproduct",
    element: <Whatsapp />,
    errorElement: <ErrorBoundry />
  },
  {
    path: "/clientproducts",
    element: <EditProducts />
  },
  {
    path: "/detailtocheckout",
    element: <DetailToCheckout />
  },
  {
    path: "/grocery/products",
    element: <Main />
  },
  {
    path: "/list/",
    element: <GroceryList />,
    children: [
      {
        path: "grocery/:main",
        element: <Offer />,
        errorElement: <ErrorBoundry />
      },
      {
        path: "grocery/:main/:subproduct",
        element: <GroceryDialog />,
        errorElement: <ErrorBoundry />
      }
    ]
  },
  {
    path: "organic-grocery/:item/:subproduct",
    element: <OrganicProductpage />,
    errorElement: <ErrorBoundry />
  },
  {
    path: "/thankyoupage",
    element: <ThankYouPage />,
    errorElement: <ErrorBoundry />
  },
  {
    path: "*",
    element: <Navigate to="/" replace />
  }
]);

const Routes = (props) => {
  return(  <RouterProvider router={router} {...props} />)

};
export default Routes;